import { useMemo } from "react"
import { useSearchParams } from "react-router"
import { useTranslation } from "react-i18next"
import { LoginForm } from "./components"
import { AuthGuard, AuthRedirectAlert } from "@/components/Auth"
import { getProviderBrand } from "@/lib/brand"
import { ErrorCode } from "@/constants/errors"

const Login = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const { icon: IconComponent } = getProviderBrand()
  const invitationError = useMemo(() => {
    const rawErrorCode = searchParams.get("error_code")
    const errorCode = rawErrorCode ? Number(rawErrorCode) : null

    if (errorCode === ErrorCode.END_USER_LIMIT_EXCEEDED) {
      return {
        title: t("common.auth.login.invitationUnavailable.title"),
        description: t("common.auth.login.invitationUnavailable.description"),
      }
    }

    if (rawErrorCode) {
      return {
        title: t("common.auth.login.errors.title"),
        description: t(`common.auth.login.errorCodes.${rawErrorCode}`, {
          defaultValue: t("common.auth.login.errors.generic"),
        }),
      }
    }

    return null
  }, [searchParams, t])

  return (
    <AuthGuard>
      <div className="container h-[600px] flex-col items-center justify-center md:grid lg:max-w-none lg:px-0">
        <div className="mx-auto flex w-full flex-col justify-center items-center sm:w-[400px]">
          <IconComponent className="w-16 h-16 mb-4" />
          {invitationError && (
            <AuthRedirectAlert
              title={invitationError.title}
              description={invitationError.description}
            />
          )}
          <LoginForm />
        </div>
      </div>
    </AuthGuard>
  )
}

export default Login
